import { colors, font, maxWidth } from "../styles/theme";
import { objectTypes } from "../data/company";

// Лента «Дома · Коттеджи · Коммерческие объекты» с красными точками-маркерами.
// Точка и текст связаны в одну группу — переносятся вместе.
export default function ObjectTypesBar({ dot = 9, fontSize = "clamp(16px,2.4vw,26px)" }) {
  return (
    <div
      className="objtypes-bar"
      style={{
        maxWidth,
        margin: "0 auto",
        padding: "20px 22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 18,
        flexWrap: "wrap",
      }}
    >
      {objectTypes.map((t) => (
        <span
          key={t}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ flex: "none", width: dot, height: dot, borderRadius: "50%", background: colors.red }} />
          <span
            style={{
              fontFamily: font.display,
              fontWeight: 700,
              fontSize,
              letterSpacing: ".05em",
              textTransform: "uppercase",
            }}
          >
            {t}
          </span>
        </span>
      ))}
    </div>
  );
}
